import {
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import Breakpoints from "../mediaQuery";
import { ZoomInIcon } from "@root/assets/icons/zoomIn";
import { ZoomOutIcon } from "@root/assets/icons/zoomout";

const ImageSliderFeature = ({
  scale,
  setScale,
  incrementScale,
  decrementScale,
}: any) => {
  const { sm } = Breakpoints();
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bottom: "10px",
          marginTop: "10px",
        }}
      >
        <ZoomInIcon
          onClick={incrementScale}
          width={sm ? "30px" : "40px"}
          position={"relative"}
        />
        <Slider
          width={sm ? "200px" : "50%"}
          aria-label="slider-ex-2"
          colorScheme="pink"
          onChange={(val) => setScale(Number(val / 10))}
          value={scale * 10}
          min={0}
          max={100}
        >
          <SliderTrack bg="#000">
            <SliderFilledTrack bg={"#000"} />
          </SliderTrack>
          <SliderThumb bg={"#000"} />
        </Slider>
        <ZoomOutIcon
          onClick={decrementScale}
          width={{ base: "20px", md: sm ? "30px" : "40px" }}
          position={"relative"}
        />
      </div>
    </>
  );
};

export default ImageSliderFeature;
